import { MultiSelect } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';
import { i18nKeys } from 'locales';
import { useTranslation } from 'locales/logic';
import type { MailsSearchParams } from 'modules/Mails/hooks/use-load-mails';
import {
  MAIL_CATEGORIES,
  MAIL_CATEGORY_LABELS,
  type MailCategory,
} from 'modules/Mails/types/mail-category';

type MailCategoryFilterBarProps = {
  form: UseFormReturnType<MailsSearchParams>;
};

export const MailCategoryFilterBar = ({ form }: MailCategoryFilterBarProps) => {
  const { t } = useTranslation();

  const categorySelectData = MAIL_CATEGORIES.map(category => ({
    value: category,
    label: t(MAIL_CATEGORY_LABELS[category]),
  }));

  return (
    <MultiSelect
      size="xs"
      clearable
      placeholder={t(i18nKeys.EXTERNAL_MAIL.CATEGORY_FILTER_PLACEHOLDER)}
      data={categorySelectData}
      value={form.values.categories}
      onChange={value => form.setFieldValue('categories', value as MailCategory[])}
      style={{ maxWidth: 400, minWidth: 200 }}
    />
  );
};
